<app-booked-flight-ticket [tickets]="[ticket]" [status]="status"
  (copyValue)="copyText($event)" (copyTicketNumber)="copyText($event, 'Ticket copiado')"
  (cancelRequested)="cancelTicket()">
</app-booked-flight-ticket>
